import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import CreateViewEditPickList from "./create-view-edit-picklist";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import errorToast from "../../../components/helper-components/error-toast";
import { ViewPickList as viewPickListAction } from "../../../redux/actions/sales-action";

const EditPickList = () => {
  const { pickListId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pickListHeader, setPickListHeader] = useState({});
  const [vendorDetails, setVendorDetails] = useState([]);
  const [items, setItems] = useState([]);

  useEffect(() => {
    dispatch(viewPickListAction(pickListId, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setPickListHeader(data?.data?.pickListHeader ?? {});
    setVendorDetails(data?.data?.vendorDetails ?? []);
    setItems(data?.data?.itemData ?? []);
    setLoading(false);
  };
  const onError = (err) => {
    setLoading(false);
    navigate(-1);
    errorToast(err?.data?.message || "Failed to load pick list");
  };

  const isEditable =
    pickListHeader?.status === "draft" || pickListHeader?.status === "partial";

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="Edit Pick List">
          <CreateViewEditPickList
            vendorDetails={vendorDetails}
            itemData={items}
            disabled={!isEditable}
            page="edit"
            standAlone={true}
            pageType="picklist"
            pickListId={pickListId}
            warehouseId={pickListHeader?.warehouse_id}
            initialPickerId={pickListHeader?.picker_id}
            initialPickerName={pickListHeader?.picker_name}
            status={pickListHeader?.status}
          />
        </InnerLayout>
      )}
    </>
  );
};

export default EditPickList;
